<mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden">
  <mat-card-header class="mat-mdc-card-header bg-primary p-10 m-b-15">
    <mat-card-title class="mat-mdc-card-title text-white">
      {{'item'|translate}} {{ClassIndex}}
    </mat-card-title>
    <div class="d-flex divIcons">
      <i-tabler name="copy" title="{{ 'Copy' | translate }}" class="icon-20 deleteIcon cursor-pointer" (click)="Copy()" ></i-tabler>
      <i-tabler name="trash" *ngIf="ClassIndex!=1" class="icon-20 deleteIcon cursor-pointer" (click)="RemoveCostCalculationForm()"></i-tabler>
    </div>
  </mat-card-header>
  <mat-card-content class="mat-mdc-card-content text-center">
    <form [formGroup]="childForm">
      <div class="row">
        <div class="col-md-2">
          <mat-form-field appearance="outline" class="w-100 m-b-10" [floatLabel]="floatLabel()">
            <mat-select name="TypeId" formControlName="typeId_{{formIndex}}"
              (selectionChange)="ChangeType($event)" placeholder="Type">
              <mat-option value=""> {{ 'SelectType' | translate }} </mat-option>
              <mat-option [value]="type.id" *ngFor="let type of AllSubCategory">
                {{type.subCategory}}
              </mat-option>
            </mat-select>


            @if(get('typeId_',formIndex)?.touched && get('typeId_',formIndex)?.invalid)
            {
            <mat-hint class="m-b-16 error-msg">
              @if(get('typeId_',formIndex)?.errors && get('typeId_',formIndex)?.errors!['required'])
              {
              <div class="text-error"> {{ 'EnterType' | translate }}</div>
              }
            </mat-hint>
            }
            <mat-label>{{ 'Type' | translate }} </mat-label>
          </mat-form-field>
        </div>

        <div class="col-md-2">
          <mat-form-field appearance="outline" class="w-100 m-b-10" [floatLabel]="floatLabel()">
            <mat-select name="ColorId" formControlName="colorId_{{formIndex}}"
              (selectionChange)="ChangeColor($event)">
              <mat-option value=""> {{ 'SelectColor' | translate }} </mat-option>
              <mat-option [value]="color.id" *ngFor="let color of ColorList">{{color.colorName}} </mat-option>
            </mat-select>

            @if(get('colorId_',formIndex)?.touched && get('colorId_',formIndex)?.invalid)
            {
            <mat-hint class="m-b-16 error-msg">
              @if(get('colorId_',formIndex)?.errors && get('colorId_',formIndex)?.errors!['required'])
              {
              <div class="text-error"> {{ 'EnterColor' | translate }}</div>
              }
            </mat-hint>
            }
            <mat-label>{{ 'Color' | translate }} </mat-label>
          </mat-form-field>
        </div>
        <div class="col-md-2" *ngIf="DisplayGlassType">
          <mat-form-field appearance="outline" class="w-100 m-b-10" [floatLabel]="floatLabel()">
            <mat-select name="GlassTypeId" formControlName="glassTypeId_{{formIndex}}"
              (selectionChange)="ChangeGlassType($event)">
              <mat-option value=""> {{ 'SelectGlassType' | translate }} </mat-option>
              <mat-option [value]="type.id" *ngFor="let type of GlassTypeList">{{type.name}} </mat-option>
            </mat-select>

            @if(get('glassTypeId_',formIndex)?.touched && get('glassTypeId_',formIndex)?.invalid)
            {
            <mat-hint class="m-b-16 error-msg">
              @if(get('glassTypeId_',formIndex)?.errors && get('glassTypeId_',formIndex)?.errors!['required'])
              {
              <div class="text-error"> {{ 'EnterType' | translate }}</div>
              }
            </mat-hint>
            }
            <mat-label> {{ 'SelectGlassType' | translate }}</mat-label>
          </mat-form-field>
        </div>



        <div class="col-md-2">
          <mat-form-field appearance="outline" class="w-100 m-b-10" [floatLabel]="floatLabel()">
            <mat-select name="halkId" formControlName="halkId_{{formIndex}}"
              (selectionChange)="ChangeHalkType($event)">
              <mat-option value=""> اختار نوع الحلق </mat-option>
<mat-option [value]="type.id" *ngFor="let type of filteredHalkTypeList">
  {{type.name}}
</mat-option>
            </mat-select>

            <mat-label>اختار نوع الحلق</mat-label>
          </mat-form-field>
        </div>


        <div class="col-md-2">
          <mat-form-field appearance="outline" class="w-100 m-b-10">
            <mat-label>{{ 'width' | translate }} </mat-label>
            <input matInput class="txt" type="number" onwheel="return false;" placeholder="{{ 'width' | translate }} "
              formControlName="width_{{formIndex}}" maxlength="3" minlength="1" #width
              (focus)="GetFocusPlaceholder(width,'Meter')" />

            @if(get('width_',formIndex)?.touched && get('width_',formIndex)?.invalid)
            {
            <mat-hint class="m-b-16 error-msg">
              @if(get('width_',formIndex)?.errors && get('width_',formIndex)?.errors!['required'])
              {
              <div class="text-error"> {{ 'EnterWidth' | translate }}</div>
              }
            </mat-hint>
            }
          </mat-form-field>
        </div>

        <div class="col-md-2">
          <mat-form-field appearance="outline" class="w-100 m-b-10">
            <mat-label>{{ 'Length' | translate }} </mat-label>
            <input matInput class="txt" type="number" onwheel="return false;" placeholder="{{ 'Length' | translate }} "
              formControlName="height_{{formIndex}}" maxlength="3" minlength="1" #length
              (focus)="GetFocusPlaceholder(length,'Meter')" />

            @if(get('height_',formIndex)?.touched && get('height_',formIndex)?.invalid)
            {
            <mat-hint class="m-b-16 error-msg">
              @if(get('height_',formIndex)?.errors && get('height_',formIndex)?.errors!['required'])
              {
              <div class="text-error"> {{ 'EnterLength' | translate }}</div>
              }
            </mat-hint>
            }

          </mat-form-field>
        </div>

        <div class="col-md-2">
          <mat-form-field appearance="outline" class="w-100 m-b-10">
            <mat-label>{{ 'Count' | translate }} </mat-label>
            <input matInput class="txt" type="number" onwheel="return false;" placeholder="{{ 'Count' | translate }} "
              formControlName="count_{{formIndex}}" maxlength="3" minlength="1" />

            @if(get('count_',formIndex)?.touched && get('count_',formIndex)?.invalid)
            {
            <mat-hint class="m-b-16 error-msg">
              @if(get('count_',formIndex)?.errors && get('count_',formIndex)?.errors!['required'])
              {
              <div class="text-error"> {{ 'EnterCount' | translate }}</div>
              }
            </mat-hint>
            }

          </mat-form-field>
        </div>

        <div class="col-md-2">
          <mat-form-field appearance="outline" class="w-100 m-b-10">
            <mat-label>{{ 'PricePerMeterForCustomer' | translate }} </mat-label>
            <input matInput class="txt" type="number" onwheel="return false;" placeholder="{{ 'PricePerMeterForCustomer' | translate }} "
              formControlName="price_{{formIndex}}" maxlength="3" minlength="1" #price
              (focus)="GetFocusPlaceholder(price,'EGP')" />

            @if(get('price_',formIndex)?.touched && get('price_',formIndex)?.invalid)
            {
            <mat-hint class="m-b-16 error-msg">
              @if(get('price_',formIndex)?.errors && get('price_',formIndex)?.errors!['required'])
              {
              <div class="text-error"> {{ 'EnterPrice' | translate }}</div>
              }
            </mat-hint>
            }
          </mat-form-field>
        </div>
      </div>

      <mat-divider style="margin-bottom: 20px;"></mat-divider>

      <div class="row divChecks">
        <div class="col-md-3 mb-2" *ngFor="let cat of AllCostCalcAddsNames">
          <mat-checkbox color="primary" (change)="AddDetails($event,cat)"
            [checked]="checkSelected(cat)">
            {{'Add'|translate}} {{cat.name}}
          </mat-checkbox>
        </div>
      </div>

      <mat-divider style="margin-top: 20px;margin-bottom: 50px;"></mat-divider>
      <div *ngFor="let cat of AllCostCalcAddsNames">
        @if(cat.widthAndHeight){
        <app-add-details *ngIf="costCalcData.includes(cat)" [childForm]="childForm" [formGroupName]="formGroupName"
          [CostCalc]="cat"></app-add-details>
        }
        @else {
        <app-add-cost *ngIf="costCalcData.includes(cat)" [childForm]="childForm" [formGroupName]="formGroupName"
          [CostCalc]="cat"></app-add-cost>
        }
      </div>
    </form>
  </mat-card-content>
</mat-card>
